export const findEnumViolatorAddressStatusForLanguage = (i18n, value) => {
  if (i18n.language === "en") {
    if (value === "") {
      return "DEFAULT";
    }
    if ("foreign".startsWith((value + "").toLowerCase())) {
      return "FOREIGN";
    }
    if ("determined".startsWith((value + "").toLowerCase())) {
      return "DETERMINED";
    }
    if ("undetermined".startsWith((value + "").toLowerCase())) {
      return "UNDETERMINED";
    }
    if ("unknown".startsWith((value + "").toLowerCase())) {
      return "UNKNOWN";
    }
    if ("new".startsWith((value + "").toLowerCase())) {
      return "NEW";
    }
    if ("requested".startsWith((value + "").toLowerCase())) {
      return "REQUESTED";
    }
    if ("lookup pending".startsWith((value + "").toLowerCase())) {
      return "LOOKUP_PENDING";
    }
    if ("lookup in progress".startsWith((value + "").toLowerCase())) {
      return "LOOKUP_IN_PROGRESS";
    }
    if ("lookup cancelled".startsWith((value + "").toLowerCase())) {
      return "LOOKUP_CANCELLED";
    }
    if ("reuse pending".startsWith((value + "").toLowerCase())) {
      return "REUSE_PENDING";
    }
    return "DEFAULT";
  }
  if (i18n.language === "de") {
    if (value === "") {
      return "DEFAULT";
    }
    if ("ausländisch".startsWith((value + "").toLowerCase())) {
      return "FOREIGN";
    }
    if ("bestimmt".startsWith((value + "").toLowerCase())) {
      return "DETERMINED";
    }
    if ("unbestimmt".startsWith((value + "").toLowerCase())) {
      return "UNDETERMINED";
    }
    if ("unbekannt".startsWith((value + "").toLowerCase())) {
      return "UNKNOWN";
    }
    if ("neu".startsWith((value + "").toLowerCase())) {
      return "NEW";
    }
    if ("angefordert".startsWith((value + "").toLowerCase())) {
      return "REQUESTED";
    }
    if ("abfrage ausstehend".startsWith((value + "").toLowerCase())) {
      return "LOOKUP_PENDING";
    }
    if ("abfrage in bearbeitung".startsWith((value + "").toLowerCase())) {
      return "LOOKUP_IN_PROGRESS";
    }
    if ("abfrage abgebrochen".startsWith((value + "").toLowerCase())) {
      return "LOOKUP_CANCELLED";
    }
    if ("wiederverwendung ausstehend".startsWith((value + "").toLowerCase())) {
      return "REUSE_PENDING";
    }
    return "DEFAULT";
  }
  if (i18n.language === "it") {
    if (value === "") {
      return "DEFAULT";
    }
    if ("straniero".startsWith((value + "").toLowerCase())) {
      return "FOREIGN";
    }
    if ("determinato".startsWith((value + "").toLowerCase())) {
      return "DETERMINED";
    }
    if ("indeterminato".startsWith((value + "").toLowerCase())) {
      return "UNDETERMINED";
    }
    if ("sconosciuto".startsWith((value + "").toLowerCase())) {
      return "UNKNOWN";
    }
    if ("nuovo".startsWith((value + "").toLowerCase())) {
      return "NEW";
    }
    if ("richiesto".startsWith((value + "").toLowerCase())) {
      return "REQUESTED";
    }
    if ("ricerca in attesa".startsWith((value + "").toLowerCase())) {
      return "LOOKUP_PENDING";
    }
    if ("ricerca in corso".startsWith((value + "").toLowerCase())) {
      return "LOOKUP_IN_PROGRESS";
    }
    if ("ricerca annullata".startsWith((value + "").toLowerCase())) {
      return "LOOKUP_CANCELLED";
    }
    if ("riutilizzo in attesa".startsWith((value + "").toLowerCase())) {
      return "REUSE_PENDING";
    }
    return "DEFAULT";
  }
  if (i18n.language === "fr") {
    if (value === "") {
      return "DEFAULT";
    }
    if ("étranger".startsWith((value + "").toLowerCase())) {
      return "FOREIGN";
    }
    if ("déterminé".startsWith((value + "").toLowerCase())) {
      return "DETERMINED";
    }
    if ("indéterminé".startsWith((value + "").toLowerCase())) {
      return "UNDETERMINED";
    }
    if ("inconnu".startsWith((value + "").toLowerCase())) {
      return "UNKNOWN";
    }
    if ("nouveau".startsWith((value + "").toLowerCase())) {
      return "NEW";
    }
    if ("demandé".startsWith((value + "").toLowerCase())) {
      return "REQUESTED";
    }
    if ("recherche en attente".startsWith((value + "").toLowerCase())) {
      return "LOOKUP_PENDING";
    }
    if ("recherche en cours".startsWith((value + "").toLowerCase())) {
      return "LOOKUP_IN_PROGRESS";
    }
    if ("recherche annulée".startsWith((value + "").toLowerCase())) {
      return "LOOKUP_CANCELLED";
    }
    if ("réutilisation en attente".startsWith((value + "").toLowerCase())) {
      return "REUSE_PENDING";
    }
    return "DEFAULT";
  }
};
export const findEnumValueForLanguage = (i18n, value, isParkingZone = false) => {
  // GRACE (drive-off) and PARKING_GRACE (parking zone) share one label, so the list decides which one is meant
  const graceStatus = isParkingZone ? "PARKING_GRACE" : "GRACE";
  if (i18n.language === "en") {
    if (value === "") {
      return "DEFAULT";
    }
    if ("paid".startsWith((value + "").toLowerCase())) {
      return "PAID";
    }
    if ("overrdue".startsWith((value + "").toLowerCase())) {
      return "OVERDUE";
    }
    if ("canceled".startsWith((value + "").toLowerCase())) {
      return "STOPPED";
    }
    if ("due".startsWith((value + "").toLowerCase())) {
      return "ISSUED";
    }
    if ("downpaid".startsWith((value + "").toLowerCase())) {
      return "DOWNPAID";
    }
    if ("complited".startsWith((value + "").toLowerCase())) {
      return "DONE";
    }
    if ("new".startsWith((value + "").toLowerCase())) {
      return "PENDING";
    }
    if("grace".startsWith((value + "").toLowerCase())) {
      return graceStatus;
    }
    if("wait".startsWith((value + "").toLowerCase())) {
      return "WAIT";
    }
    if("pending activation".startsWith((value + "").toLowerCase())) {
      return "PENDING_ACTIVATION";
    }
    return "DEFAULT";
  }
  if (i18n.language === "de") {
    if (value === "") {
      return "DEFAULT";
    }
    if ("bezahlt".startsWith((value + "").toLowerCase())) {
      return "PAID";
    }
    if ("überfällig".startsWith((value + "").toLowerCase())) {
      return "OVERDUE";
    }
    if ("storniert".startsWith((value + "").toLowerCase())) {
      return "STOPPED";
    }
    if ("fällig".startsWith((value + "").toLowerCase())) {
      return "ISSUED";
    }
    if ("angezahlt".startsWith((value + "").toLowerCase())) {
      return "DOWNPAID";
    }
    if ("erledigt".startsWith((value + "").toLowerCase())) {
      return "DONE";
    }
    if ("neu".startsWith((value + "").toLowerCase())) {
      return "PENDING";
    }
    if("schonfrist".startsWith((value + "").toLowerCase())) {
      return graceStatus;
    }
    if("warten".startsWith((value + "").toLowerCase())) {
      return "WAIT";
    }
    if("ausstehende aktivierung".startsWith((value + "").toLowerCase())) {
      return "PENDING_ACTIVATION";
    }
    return "DEFAULT";
  }
  if (i18n.language === "fr") {
    if (value === "") {
      return "DEFAULT";
    }
    if ("payée".startsWith((value + "").toLowerCase())) {
      return "PAID";
    }
    if ("überfällig".startsWith((value + "").toLowerCase())) {
      return "OVERDUE";
    }
    if ("annulée".startsWith((value + "").toLowerCase())) {
      return "STOPPED";
    }
    if ("échue".startsWith((value + "").toLowerCase())) {
      return "ISSUED";
    }
    if ("acompte".startsWith((value + "").toLowerCase())) {
      return "DOWNPAID";
    }
    if ("faite".startsWith((value + "").toLowerCase())) {
      return "DONE";
    }
    if ("nouveau".startsWith((value + "").toLowerCase())) {
      return "PENDING";
    }
    if("grace".startsWith((value + "").toLowerCase())) {
      return graceStatus;
    }
    if("attendre".startsWith((value + "").toLowerCase())) {
      return "WAIT";
    }
    if("en attente d'activation".startsWith((value + "").toLowerCase())) {
      return "PENDING_ACTIVATION";
    }
    return "DEFAULT";
  }
  if (i18n.language === "it") {
    if (value === "") {
      return "DEFAULT";
    }
    if ("pagato".startsWith((value + "").toLowerCase())) {
      return "PAID";
    }
    if ("scaduto".startsWith((value + "").toLowerCase())) {
      return "OVERDUE";
    }
    if ("annullato".startsWith((value + "").toLowerCase())) {
      return "STOPPED";
    }
    if ("dovuto".startsWith((value + "").toLowerCase())) {
      return "ISSUED";
    }
    if ("acconto pagato".startsWith((value + "").toLowerCase())) {
      return "DOWNPAID";
    }
    if ("evaso".startsWith((value + "").toLowerCase())) {
      return "DONE";
    }
    if ("nuovo".startsWith((value + "").toLowerCase())) {
      return "PENDING";
    }
    if("grazia".startsWith((value + "").toLowerCase())) {
      return graceStatus;
    }
    if("attendere".startsWith((value + "").toLowerCase())) {
      return "WAIT";
    }
    if("in attesa di attivazione".startsWith((value + "").toLowerCase())) {
      return "PENDING_ACTIVATION";
    }
    return "DEFAULT";
  }
};

export const findEnumLegalStatusValueForLanguage = (i18n, value) => {
  if (value === "-") {
    return "NONE";
  }
  if (i18n.language === "en") {
    if (value === "") {
      return "DEFAULT";
    }
    if ("reminded".startsWith((value + "").toLowerCase())) {
      return "REMINDED";
    }
    if ("sued".startsWith((value + "").toLowerCase())) {
      return "SUED";
    }
    if ("terminated".startsWith((value + "").toLowerCase())) {
      return "TERMINATED";
    }
    if ("invoice sent".startsWith((value + "").toLowerCase())) {
      return "INVOICE_SENT";
    }

    if ("Enforced".startsWith((value + "").toLowerCase())) {
      return "OPERATION_DOC_SENT";
    }
    if ("to sue".startsWith((value + "").toLowerCase())) {
      return "TO_SUE";
    }
    if ("to enforce".startsWith((value + "").toLowerCase())) {
      return "TO_BE_ENFORCED";
    }
    if ("penalty fee demanded".startsWith((value + "").toLowerCase())) {
      return "PENALTY_FEE_DEMANDED";
    }
    if ("last reminder".startsWith((value + "").toLowerCase())) {
      return "LAST_REMINDER";
    }

    return "DEFAULT";
  }

  if (i18n.language === "de") {
    if (value === "") {
      return "DEFAULT";
    }
    if ("gemahnt".startsWith((value + "").toLowerCase())) {
      return "REMINDED";
    }
    if ("verzeigt".startsWith((value + "").toLowerCase())) {
      return "SUED";
    }
    if ("abgeschlossen".startsWith((value + "").toLowerCase())) {
      return "TERMINATED";
    }
    if ("rg versendet".startsWith((value + "").toLowerCase()) || "rechnung versendet".startsWith((value + "").toLowerCase())) {
      return "INVOICE_SENT";
    }

    if ("betrieben".startsWith((value + "").toLowerCase())) {
      return "OPERATION_DOC_SENT";
    }
    if ("zu verzeigen".startsWith((value + "").toLowerCase())) {
      return "TO_SUE";
    }
    if ("zu betreiben".startsWith((value + "").toLowerCase())) {
      return "TO_BE_ENFORCED";
    }
    if ("strafgebühr eingefordert".startsWith((value + "").toLowerCase())) {
      return "PENALTY_FEE_DEMANDED";
    }
    if ("letzte mahnung".startsWith((value + "").toLowerCase())) {
      return "LAST_REMINDER";
    }

    return "DEFAULT";
  }
  if (i18n.language === "fr") {
    if (value === "") {
      return "DEFAULT";
    }
    if ("rappelée".startsWith((value + "").toLowerCase())) {
      return "REMINDED";
    }
    if ("dénoncée".startsWith((value + "").toLowerCase())) {
      return "SUED";
    }
    if ("fermé".startsWith((value + "").toLowerCase())) {
      return "TERMINATED";
    }
    if ("facture envoyée".startsWith((value + "").toLowerCase())) {
      return "INVOICE_SENT";
    }

    if ("poursuite en cours".startsWith((value + "").toLowerCase())) {
      return "OPERATION_DOC_SENT";
    }
    if ("à dénoncer".startsWith((value + "").toLowerCase())) {
      return "TO_SUE";
    }
    if ("introduire poursuite".startsWith((value + "").toLowerCase())) {
      return "TO_BE_ENFORCED";
    }
    if ("pénalité demandée".startsWith((value + "").toLowerCase())) {
      return "PENALTY_FEE_DEMANDED";
    }
    if ("dernier rappel".startsWith((value + "").toLowerCase())) {
      return "LAST_REMINDER";
    }

    return "DEFAULT";
  }

if (i18n.language === "it") {
  if (value === "") {
    return "DEFAULT";
  }
  if ("sollecitato".startsWith((value + "").toLowerCase())) {
    return "REMINDED";
  }
  if ("denunciato".startsWith((value + "").toLowerCase())) {
    return "SUED";
  }
  if ("completato".startsWith((value + "").toLowerCase())) {
    return "TERMINATED";
  }
  if ("fattura inviata".startsWith((value + "").toLowerCase())) {
    return "INVOICE_SENT";
  }

  if ("procedimento esecutivo attivato".startsWith((value + "").toLowerCase())) {
    return "OPERATION_DOC_SENT";
  }
  if ("to sue".startsWith((value + "").toLowerCase())) {
    return "TO_SUE";
  }
  if ("avviare rec crediti".startsWith((value + "").toLowerCase())) {
    return "TO_BE_ENFORCED";
  }
  if ("richiesta penale".startsWith((value + "").toLowerCase())) {
    return "PENALTY_FEE_DEMANDED";
  }
  if ("ultimo richiamo".startsWith((value + "").toLowerCase())) {
    return "LAST_REMINDER";
  }

  return "DEFAULT";
}
};

export const findUserStatusEnumValueForLanguage = (i18n, value) => {
  if (i18n.language === "en") {
    if (value === "") {
      return "DEFAULT";
    }
    if ("paid".startsWith((value + "").toLowerCase())) {
      return "PAID";
    }
    if ("open".startsWith((value + "").toLowerCase())) {
      return "OPEN";
    }
    if ("cancelled".startsWith((value + "").toLowerCase())) {
      return "CANCELLED";
    }
    if ("closed".startsWith((value + "").toLowerCase())) {
      return "CLOSED";
    }
    if ("wait".startsWith((value + "").toLowerCase())) {
      return "WAIT";
    }

    return "DEFAULT";
  }
  if (i18n.language === "de") {
    if (value === "") {
      return "DEFAULT";
    }
    if ("bezahlt".startsWith((value + "").toLowerCase())) {
      return "PAID";
    }
    if ("offen".startsWith((value + "").toLowerCase())) {
      return "OPEN";
    }
    if ("storniert".startsWith((value + "").toLowerCase())) {
      return "CANCELLED";
    }
    if ("geschlossen".startsWith((value + "").toLowerCase())) {
      return "CLOSED";
    }
    if ("warten".startsWith((value + "").toLowerCase())) {
      return "WAIT";
    }    

    return "DEFAULT";
  }
  if (i18n.language === "fr") {
    if (value === "") {
      return "DEFAULT";
    }
    if ("paye".startsWith((value + "").toLowerCase())) {
      return "PAID";
    }
    if ("ouvert".startsWith((value + "").toLowerCase())) {
      return "OPEN";
    }
    if ("annule".startsWith((value + "").toLowerCase())) {
      return "CANCELLED";
    }
    if ("ferme".startsWith((value + "").toLowerCase())) {
      return "CLOSED";
    }
    if ("attendre".startsWith((value + "").toLowerCase())) {
      return "WAIT";
    }

    return "DEFAULT";
  }
  if (i18n.language === "it") {
    if (value === "") {
      return "DEFAULT";
    }
    if ("pagato".startsWith((value + "").toLowerCase())) {
      return "PAID";
    }
    if ("aperto".startsWith((value + "").toLowerCase())) {
      return "OPEN";
    }
    if ("annullato".startsWith((value + "").toLowerCase())) {
      return "CANCELLED";
    }
    if ("chiuso".startsWith((value + "").toLowerCase())) {
      return "CLOSED";
    }
    if ("attendere".startsWith((value + "").toLowerCase())) {
      return "WAIT";
    }
    return "DEFAULT";
  }
};
export const modifyArrayForStatusInformation = (array, value) => {
  let newArray = array.filter((element) => 
    element.path !== "cancellationReason" && element.path !== "closeReason"
  );
  
  if (value === "DEFAULT" || value === "") {
    return newArray;
  }

  const cancellationReasons = [
    "PARKING_PERMISSION_GRANTED", "CASHIERS_MISTAKE", "PAYMENT_TERMINAL_DEFECTIVE",
    "GOODWILL", "INPUT_ERROR", "GOODWILL_BEPPO", "POOR_IMAGE_QUALITY", 
    "CUSTOMER_PAID_AT_GAS_STATION"
  ];
  
  const closeReasons = [
    "REPORTED_TO_POLICE", "INSUFFICIENT_EVIDENCE", "NO_FOLLOW_UP"
  ];
  
  if (cancellationReasons.includes(value)) {
    newArray.push({
      filter: "eq",
      path: "cancellationReason",
      value: value
    });
  } else if (closeReasons.includes(value)) {
    newArray.push({
      filter: "eq",
      path: "closeReason",
      value: value
    });
  }
  
  return newArray;
};

export const findStatusInformationEnumValueForLanguage = (i18n, value) => {
  const lowerValue = (value + "").toLowerCase();
  
  if (i18n.language === "en") {
    if (value === "") return "DEFAULT"; 
    
    // CancellationReasons
    if ("parking permission granted".startsWith(lowerValue)) return "PARKING_PERMISSION_GRANTED";
    if ("cashier's mistake".startsWith(lowerValue) || "cashiers mistake".startsWith(lowerValue)) return "CASHIERS_MISTAKE";
    if ("payment terminal defective".startsWith(lowerValue)) return "PAYMENT_TERMINAL_DEFECTIVE";
    if ("regular customer".startsWith(lowerValue)) return "GOODWILL";
    if ("input error".startsWith(lowerValue)) return "INPUT_ERROR";
    if ("goodwill beppo".startsWith(lowerValue)) return "GOODWILL_BEPPO";
    if ("poor image quality".startsWith(lowerValue)) return "POOR_IMAGE_QUALITY";
    if ("customer paid at gas station".startsWith(lowerValue)) return "CUSTOMER_PAID_AT_GAS_STATION";
    
    // CloseReasons
    if ("reported to the police".startsWith(lowerValue) || "reported".startsWith(lowerValue)) return "REPORTED_TO_POLICE";
    if ("insufficient evidence".startsWith(lowerValue)) return "INSUFFICIENT_EVIDENCE";
    if ("no follow up".startsWith(lowerValue)) return "NO_FOLLOW_UP";
    
    return "DEFAULT";
  }
  
  if (i18n.language === "de") {
    if (value === "") return "DEFAULT";
    
    // CancellationReasons
    if ("parkerlaubnis erteilt".startsWith(lowerValue)) return "PARKING_PERMISSION_GRANTED";
    if ("fehler des kassierers".startsWith(lowerValue)) return "CASHIERS_MISTAKE";
    if ("zahlungsterminal defekt".startsWith(lowerValue)) return "PAYMENT_TERMINAL_DEFECTIVE";
    if ("stammkunde".startsWith(lowerValue)) return "GOODWILL";
    if ("eingabefehler".startsWith(lowerValue)) return "INPUT_ERROR";
    if ("kulanz beppo".startsWith(lowerValue)) return "GOODWILL_BEPPO";
    if ("schlechte bildqualität".startsWith(lowerValue) || "schlechte bildqualitat".startsWith(lowerValue)) return "POOR_IMAGE_QUALITY";
    if ("kunde hat vor ort bezahlt".startsWith(lowerValue)) return "CUSTOMER_PAID_AT_GAS_STATION";
    
    // CloseReasons
    if ("verzeigt".startsWith(lowerValue)) return "REPORTED_TO_POLICE";
    if ("beweismaterial ungenügend".startsWith(lowerValue) || "beweismaterial ungenugend".startsWith(lowerValue)) return "INSUFFICIENT_EVIDENCE";
    if ("keine weiterverfolgung".startsWith(lowerValue)) return "NO_FOLLOW_UP";
    
    return "DEFAULT";
  }
  
  if (i18n.language === "fr") {
    if (value === "") return "DEFAULT";
    
    // CancellationReasons
    if ("permis de stationnement accordé".startsWith(lowerValue) || "permis de stationnement accorde".startsWith(lowerValue)) return "PARKING_PERMISSION_GRANTED";
    if ("erreur du caissier".startsWith(lowerValue)) return "CASHIERS_MISTAKE";
    if ("terminal de paiement en panne".startsWith(lowerValue)) return "PAYMENT_TERMINAL_DEFECTIVE";
    if ("client régulier".startsWith(lowerValue) || "client regulier".startsWith(lowerValue) || "geste commercial".startsWith(lowerValue)) return "GOODWILL";
    if ("erreur de saisie".startsWith(lowerValue)) return "INPUT_ERROR";
    if ("bonne volonté beppo".startsWith(lowerValue) || "bonne volonte beppo".startsWith(lowerValue)) return "GOODWILL_BEPPO";
    if ("mauvaise qualité d'image".startsWith(lowerValue) || "mauvaise qualite d'image".startsWith(lowerValue)) return "POOR_IMAGE_QUALITY";
    if ("client payé sur place".startsWith(lowerValue) || "client paye sur place".startsWith(lowerValue)) return "CUSTOMER_PAID_AT_GAS_STATION";
    
    // CloseReasons
    if ("dénoncé".startsWith(lowerValue) || "denonce".startsWith(lowerValue)) return "REPORTED_TO_POLICE";
    if ("preuves insuffisantes".startsWith(lowerValue)) return "INSUFFICIENT_EVIDENCE";
    if ("pas de suivi".startsWith(lowerValue)) return "NO_FOLLOW_UP";
    
    return "DEFAULT";
  }
  
  if (i18n.language === "it") {
    if (value === "") return "DEFAULT";
    
    // CancellationReasons
    if ("permesso di parcheggio concesso".startsWith(lowerValue)) return "PARKING_PERMISSION_GRANTED";
    if ("l'errore del cassiere".startsWith(lowerValue) || "errore del cassiere".startsWith(lowerValue)) return "CASHIERS_MISTAKE";
    if ("terminale di pagamento difettoso".startsWith(lowerValue)) return "PAYMENT_TERMINAL_DEFECTIVE";
    if ("clienti regolari".startsWith(lowerValue)) return "GOODWILL";
    if ("errore di inserimento".startsWith(lowerValue)) return "INPUT_ERROR";
    if ("buona volontà beppo".startsWith(lowerValue) || "buona volonta beppo".startsWith(lowerValue)) return "GOODWILL_BEPPO";
    if ("scarsa qualità dell'immagine".startsWith(lowerValue) || "scarsa qualita dell'immagine".startsWith(lowerValue)) return "POOR_IMAGE_QUALITY";
    if ("il cliente ha pagato sul posto".startsWith(lowerValue)) return "CUSTOMER_PAID_AT_GAS_STATION";
    
    // CloseReasons
    if ("denunciato".startsWith(lowerValue)) return "REPORTED_TO_POLICE";
    if ("prove insufficienti".startsWith(lowerValue)) return "INSUFFICIENT_EVIDENCE";
    if ("nessun follow-up".startsWith(lowerValue)) return "NO_FOLLOW_UP";
    
    return "DEFAULT";
  }
  
  return "DEFAULT";
};

export const mapVehicleTypeToEnglish = (i18n, value) => {
  const lowerValue = value.toLowerCase();

  if (i18n.language === "de") {
    if (lowerValue.startsWith("mot")) {
      return "Motorcycle";
    } else if (lowerValue.startsWith("aut")) {
      return "Car";
    } else if (lowerValue.startsWith("unb")) {
      return "";
    } else if (lowerValue.startsWith("and")) {
      return "Other";
    } else if (lowerValue.startsWith("lkw")) {
      return "Truck";
    }
  } else if (i18n.language === "en") {
    if (lowerValue.startsWith("mot")) {
      return "Motorcycle";
    } else if (lowerValue.startsWith("car")) {
      return "Car";
    } else if (lowerValue.startsWith("unk")) {
      return "";
    } else if (lowerValue.startsWith("oth")) {
      return "Other";
    } else if (lowerValue.startsWith("tru")) {
      return "Truck";
    }
  } else if (i18n.language === "fr") {
    if (lowerValue.startsWith("mot")) {
      return "Motorcycle";
    } else if (lowerValue.startsWith("voi")) {
      return "Car";
    } else if (lowerValue.startsWith("inc")) {
      return "";
    } else if (lowerValue.startsWith("aut")) {
      return "Other";
    } else if (lowerValue.startsWith("cam")) {
      return "Truck";
    }
  } else if (i18n.language === "it") {
    if (lowerValue.startsWith("mot")) {
      return "Motorcycle";
    } else if (lowerValue.startsWith("aut")) {
      return "Car";
    } else if (lowerValue.startsWith("sco")) {
      return "";
    } else if (lowerValue.startsWith("alt")) {
      return "Other";
    } else if (lowerValue.startsWith("cam")) {
      return "Truck";
    }
  }

  return "Other";
};

export const mapCountryCode = (value) => {
  const validCountryCodes = [
    "CH",
    "D",
    "F",
    "I",
    "A",
    "FL",
    "CZ",
    "SK",
    "SLO",
    "H",
    "B",
    "L",
    "NL",
    "PL",
    "other",
  ];

  const normalizedValue = String(value || "").trim();
  const upperValue = normalizedValue.toUpperCase();

  if (upperValue === "O") {
    return "other";
  }

  if (validCountryCodes.includes(upperValue)) {
    return upperValue;
  }

  return "";
};

export const isUnknown = (input) => {
  const lowerValue = input.toLowerCase();
  const unknownTranslations = [
    "unknown",
    "unbekannt",
    "sconosciuto",
    "inconnu",
  ];
  return unknownTranslations.some((unknown) => unknown.startsWith(lowerValue));
};

export const isOther = (input) => {
  if (!input) return false;

  const lowerValue = String(input).trim().toLowerCase();

  if (lowerValue.length <= 2) return false;

  const otherTranslations = [
    "other",
    "andere",
    "autre",
    "altro",
  ];

  return otherTranslations.some((word) => word.startsWith(lowerValue));
};
